export default "__VITE_ASSET__BgnioKM1__"